<template>
  <template-item layout="flex" label="备选项">
    <div
      v-for="(it, idx) in dataSource"
      :key="idx"
      class="flex-fill flex flex-row v-center"
    >
      <span
        class="clr-blue flex-auto"
        style="padding-right: 5px; font-size: 16px;"
      >
        {{ getOrderText(it.order) }}
      </span>
      <el-input
        size="mini"
        :value="it.text"
        @input="(e) => handleChangeItem(idx, e)"
        class="flex-fill"
      />
      <span
        class="flex-auto"
        style="padding-left: 5px; color: red; cursor: pointer; font-size: 16px;"
        ><i class="el-icon-delete" @click="() => handleRemove(idx)"
      /></span>
    </div>
    <div class="flex-auto">
      <el-button type="text" size="mini" icon="" @click="handleAdd"
        >添加选项</el-button
      >
    </div>
  </template-item>
</template>
<script>
import { Button, Input } from "element-ui";

import ItemSection from "@/components/excel/designer/configure/value/area/SelectorConstraintWrapper";
import TemplateItem from "@/components/excel/designer/template/TemplateItem";

export default {
  name: "other-selector-constraint",
  components: {
    TemplateItem,
    [ItemSection.name]: ItemSection,
    [Input.name]: Input,
    [Button.name]: Button,
  },
  props: {
    forbiddenValues: {
      type: Array,
    },
    allowedValues: {
      type: Array,
    },
    dataSource: {
      type: Array,
    },
  },
  computed: {
    allowedData: {
      get() {
        return this.$props.allowedValues;
      },
      set(value) {
        this.changeAllowed(value);
      },
    },
    forbiddenData: {
      get() {
        return this.$props.forbiddenValues;
      },
      set(value) {
        this.changeForbidden(value);
      },
    },
  },
  data() {
    return {
      constraintType: 1,
    };
  },
  methods: {
    handleChangeConstraintType(value) {
      const { section } = this.$refs;
      if (section) {
        if (section.isLatest(value)) {
          // 永远取最新的
          this.changeAllowed(null);
        } else if (section.isCurrent(value)) {
          // 取当前的所有
          this.changeAllowed(this.getAllIds());
        }
      }
    },
    changeAllowed(value) {
      this.$emit("update:allowed-values", value);
      this.$emit("change-allowed-values", value);
    },
    changeForbidden(value) {
      this.$emit("update:forbidden-values", value);
      this.$emit("change-forbidden-values", value);
    },
    changeDataSource(value) {
      this.$emit("update:data-source", value);
      this.$emit("change-data-source", value);
    },
    getAllIds() {
      const { dataSource } = this.$props;
      return dataSource.map((it) => it);
    },
    handleAdd() {
      const { dataSource } = this.$props;
      const order = dataSource.length + 1;
      const current = [...dataSource, { order, text: null }];
      this.changeDataSource(current);
    },
    handleRemove(idx) {
      const { dataSource } = this.$props;
      const current = dataSource.map((it) => {
        if (it.order > idx) {
          return { ...it, order: it.order - 1 };
        }
        return it;
      });
      current.splice(idx, 1);
      this.changeDataSource(current);
    },
    handleChangeItem(idx, value) {
      const { dataSource } = this.$props;
      const current = [...dataSource];
      current[idx].text = value;
      this.changeDataSource(current);
      console.log(value);
    },
    getOrderText(index) {
      return `${index}`.padStart(2, "0");
    },
  },
};
</script>
<style scoped>
div >>> .el-input > input {
  border: none;
  border-bottom: 1px solid #cccccc;
  border-radius: 0;
  padding: 0 5px;
}
</style>
